import React from "react";
import SpacerComponent from "../../components/SpacerComponent";
import { SpacerProps } from "./SpacerProps";

function Spacer({ backgroundColor, size }: SpacerProps) {
  return <SpacerComponent backgroundColor={backgroundColor} size={size} />;
}

export default Spacer;
